/* eslint-disable array-callback-return */
/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import SalesIcon from "../../../../../assets/images/icon_menus/SalesIcon.json";
import clsx from "clsx";
import { Col, Image, Row, Space, Modal } from "antd";
import {
    Button, TextField, Box, Switch, Tooltip, InputLabel, Checkbox, TableRow, TableCell, Typography, InputAdornment, FormControlLabel
} from "@mui/material";
import crudActions from "../../../../CRUD/redux/actions";
import infoMarkIcon from "../../../../../assets/images/icon_actions/infoMark.svg";
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import DateIcon from "../../../../Shared/components/Icons/Date";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import { useDispatch, useSelector } from "react-redux";
import gstActions from "../../../../Admin/Setup/redux/actions";
import actions from "../../redux/actions";
import transactionsActions from "../../../Transactions/redux/actions";
import { emptyValidation } from "../../../../../helpers/validation";
import usePrevious from "../../../../Shared/components/Previous";
import { useParams } from "react-router-dom";
import businessActions from "../../../../Admin/Home/redux/actions";
import { toast } from 'react-toastify';
import moment from 'moment';
import { capitalizeFirstLetter, currencyFormat, checkCRUDViewPermission, checkCRUDPermission, scrollToError, getColumnWidth, idNamingConversion } from "../../../../../helpers/utilities";
import { selectInvoiceHead } from "../../../../../config/constant";
import CustomAlert from "../../../../Shared/components/CustomAlert";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import IconButton from '@mui/material/IconButton';
import { AESEncrypt, AESDecrypt } from "../../../../../helpers/Crypto";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { useEventListener } from "../../../../../helpers/useEventListener";
import { CustomModal } from "../../../../Shared/components/DeleteModal";


const CustomerPaymentCreate = (props) => {
    const { customerDetails } = useSelector(state => state.salesManagementReducer);
    const { salesInvoiceDetails, loader } = useSelector(state => state.salesTransactionsReducer);
    const { currencyDetails, mopDetails } = useSelector(state => state.adminSetupReducer);
    const { getTeamData } = useSelector(state => state.homeReducer);
    const { createDetails, createError, createLoader, createData } = useSelector(state => state.crudReducer);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selected, setSelected] = useState([]);
    const [paymentDate, setPaymentDate] = useState(new Date());
    const [mopId, setMopId] = useState('');
    const [salesRepId, setSalesRepId] = useState('');
    const [amount, setAmount] = useState(0);
    const [hiddenAmount, setHiddenAmount] = useState(0);
    const [currencyId, setCurrencyId] = useState('');
    const [reference, setReference] = useState('');
    //const [status, setStatus] = useState('CREATED');
    const [description, setDescription] = useState('');
    const [paymentAmount, setPaymentAmount] = useState(0.00);
    const [balanceAmount, setBalanceAmount] = useState(0.00);
    const [markedAmount, setMarkedAmount] = useState(0.00);
    const [errorCustomerId, setErrorCustomerId] = useState(false);
    const [errorCurrency, setErrorCurrency] = useState(false);
    //const [errorMopId, setErrorMopId] = useState(false);
    const [errorAmount, setErrorAmount] = useState(false);
    const [errorDate, setErrorDate] = useState(false);
    const [autoMark, setAutoMark] = useState(false);
    const [errorCommon, setErrorCommon] = useState(false);
    const [custmerChange, setCustmerChange] = useState(false);
    const dispatch = useDispatch();
    const childRef = useRef('');
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const { history, onRequestSort, sortOrder, sortBy } = props;
    let { paymentCustomerId, invoiceId } = useParams();
    const decryptedId = AESDecrypt(paymentCustomerId);

    const [customerId, setCustomerId] = useState('');
    const [customerSerialNo, setCustomerSerialNo] = useState('');
    const { roleManagement } = useSelector(state => state.authReducer);
    const [confirm, setConfirm] = useState(false);

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    useEffect(() => {
        if (roleManagement !== '' && checkCRUDViewPermission('Customer Payment', 'create', history, 'Sales')) {
            loadTasks();
        }
        return () => {
            dispatch({ type: transactionsActions.CLEAR_SALES_TRANSACTION_DETAILS_START });
            dispatch({ type: actions.CLEAR_MANAGEMENT_DETAILS_SUCCESS });
        }
    }, [roleManagement]);

    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 83) {
            e.preventDefault();
            handleSubmit(e);
        } else if (confirm) {
            handleSubmit('', 'CONFIRMED');
        } else if (e.altKey && e.keyCode === 79) {
            e.preventDefault();
            handleConfirmSubmit();
        }
    };

    useEventListener("keydown", handleKeyDown);

    const emptyState = () => {
        setErrorCustomerId(false);
        setErrorCurrency(false);
        // setErrorMopId(false);
        setErrorAmount(false);
        setErrorCommon(false);
    }

    const loadTasks = useCallback(() => {
        if (paymentCustomerId !== undefined || decryptedId !== 0) {
            customerApi('', decryptedId);
        } else {
            customerApi();
        }
        // dispatch({
        //     type: actions.CUSTOMER_DETAILS_START, url: 'customerProfile', filter: {
        //         order: 'id desc'
        //     }
        // });
        dispatch({
            type: businessActions.TEAM_DETAILS_START, url: 'team', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: gstActions.CURRENCY_DETAILS_START, url: 'currency', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: gstActions.MOP_DETAILS_START, url: 'mop', filter: {
                order: 'id  desc'
            }
        });
    });

    const customerApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: actions.CUSTOMER_DETAILS_START, url: 'customerProfile',
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: 'id desc',
                limit: 100,
                skip: 0
            },
        });
    }

    useEffect(() => {
        if (paymentCustomerId !== undefined &&
            decryptedId !== 0 &&
            customerDetails !== '' && customerDetails.length > 0 && !custmerChange) {
            let a = customerDetails.filter((el) => { return el.id === parseInt(decryptedId) });
            if (a && a?.length > 0 && a[0]?.isHold) {
                toast.error('Please release the Customer from ON-HOLD to allow for transaction to be created.');
                history.push("/sales/sales-management/customer-payment");
            }
            handleChangeCustomer((parseInt(decryptedId)));
        }
    }, [customerDetails]);


    useEffect(() => {
        if (invoiceId && salesInvoiceDetails?.length > 0) {
            let index = salesInvoiceDetails.findIndex((d, i) => parseInt(invoiceId) === d.id);
            let data = salesInvoiceDetails.filter((el) => { return el.id === parseInt(invoiceId) });
            if (data.length) {
                //let amount = data[0].invoiceAmount ? data[0].invoiceAmount - data[0].settledAmount : 0;
                let amount = parseFloat(data[0].balanceAmount);
                setAmount(amount);
                setHiddenAmount(amount);
                setTimeout(() => {
                    const element = document.getElementById(`checkbox_${index}`);
                    if (element !== null && !element.checked) {
                        element.click();
                    }
                }, 100);
            }
        }
        childRef?.current?.handleAdjustHeight();
    }, [salesInvoiceDetails]);

    const handleConfirmSubmit = () => {
        childRef?.current?.handleAdjustHeight();
        let emptyCustomer = emptyValidation('Customer Name', customerId, 'dropDown');
        //  let emptyMopId = emptyValidation('Method of payment', mopId, 'dropDown');
        let emptyCurrencyId = emptyValidation('Currency', currencyId, 'dropDown');
        let emptyAmount = emptyValidation('Amount', hiddenAmount);
        let emptyDate = emptyValidation('Date', paymentDate);
        emptyState();
        if (emptyCustomer.isValid && emptyCurrencyId.isValid && emptyAmount.isValid && emptyDate.isValid) {
            setConfirm(true);
        } else {
            setConfirm(false)
            if (emptyCustomer.errors) {
                setErrorCustomerId(emptyCustomer.errors);
            }
            // if (emptyMopId.errors) {
            //     setErrorMopId(emptyMopId.errors);
            // }
            if (emptyCurrencyId.errors) {
                setErrorCurrency(emptyCurrencyId.errors);
            }
            if (emptyAmount.errors) {
                setErrorAmount(emptyAmount.errors);
            }
            if (emptyDate.errors) {
                setErrorDate(emptyDate.errors);
            }
            scrollToError();
        }
    }

    const handleSubmit = (e = '', status = 'CREATED') => {
        if (e !== '') {
            e?.preventDefault();
        }
        childRef?.current?.handleAdjustHeight();
        let emptyCustomer = emptyValidation('Customer Name', customerId, 'dropDown');
        //let emptyMopId = emptyValidation('Method of payment', mopId, 'dropDown');
        let emptyCurrencyId = emptyValidation('Currency', currencyId, 'dropDown');
        let emptyAmount = emptyValidation('Amount', hiddenAmount);
        let emptyDate = emptyValidation('Date', paymentDate);
        emptyState();
        if (emptyCustomer.isValid && emptyCurrencyId.isValid && emptyAmount.isValid && emptyDate.isValid) {
            //setStatus(status);
            let sItems = [];
            let mItems = '';
            var items = salesInvoiceDetails && salesInvoiceDetails?.filter((el) => { return selected.find(e => e === el.id) });
            items && items.length > 0 && items.map((element, i) => {
                mItems = {
                    salesInvoiceId: element.id,
                    amountToSettle: parseFloat(element.costAmount),
                    fullySettled: (parseFloat(parseFloat(element.costAmount).toFixed(2)) === parseFloat(parseFloat(element.invoiceAmount - element.settledAmount).toFixed(2))) ? true : false
                };
                sItems.push(mItems);
            });

            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: 'customerPayment',
                title: 'Customer Payment',
                details: {
                    customerId: customerId,
                    date: paymentDate,
                    paymentAmount: parseFloat(parseFloat(hiddenAmount).toFixed(2)),
                    reference: reference,
                    paymentStatus: status,
                    description: description,
                    mopId: mopId || null,
                    currencyId: currencyId,
                    markedAmount: parseFloat(parseFloat(markedAmount).toFixed(2)),
                    items: sItems, salesRepId: salesRepId || 0
                }
            })
        } else {
            setConfirm(false)
            if (emptyCustomer.errors) {
                setErrorCustomerId(emptyCustomer.errors);
            }
            // if (emptyMopId.errors) {
            //     setErrorMopId(emptyMopId.errors);
            // }
            if (emptyCurrencyId.errors) {
                setErrorCurrency(emptyCurrencyId.errors);
            }
            if (emptyAmount.errors) {
                setErrorAmount(emptyAmount.errors);
            }
            if (emptyDate.errors) {
                setErrorDate(emptyDate.errors);
            }
            scrollToError();
        }
    };

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            toast.dismiss();
            // toast(createDetails);
            setConfirm(false);
            if (roleManagement !== '' && checkCRUDPermission('Customer Payment', 'view', 'Sales')) {
                if (paymentCustomerId || invoiceId) {
                    history.push(`/sales/sales-management/customer-payment/${AESEncrypt(createData.id)}/${AESEncrypt(paymentCustomerId || invoiceId)}/view`, 'create');
                } else {
                    history.push(`/sales/sales-management/customer-payment/${AESEncrypt(createData.id)}/view`, 'create');
                }
            } else {
                history.push(`/sales/sales-management/customer-payment/`);
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let message = createError.error.message;
            toast.dismiss();
            toast.error(message);
        }
    }, [createDetails, createError]);


    const handleChangeCustomer = (id) => {
        let cId = id;
        emptyState();
        setAutoMark(false);
        let a = customerDetails && customerDetails.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            if (a[0]?.isHold) {
                cId = 0;
                setCustomerId('');
                setMopId('');
                setSalesRepId('');
                setCurrencyId('');
                setCustomerSerialNo('');
                setErrorCustomerId('Please release the Customer Invoice from ON-HOLD to allow for transaction to be processed.');
            } else {
                setMopId(a[0].mopId > 0 ? a[0].mopId : '');
                setCurrencyId(a[0].currencyId && a[0].currencyId);
                setSalesRepId(a[0]?.salesRepId || '');
                setCustomerId(cId);
                setCustomerSerialNo(a[0].serialNo);
            }
        }

        let filter = { ["and"]: [{ customerId: cId }, { isSettled: false }] };
        let or = { ["or"]: [{ source: 'SALES SELF BILL' }, { source: 'STORE SALES INVOICE' }, { source: 'SALES ORDER' }] };
        filter['and'].push(or);
        dispatch({
            type: transactionsActions.SALES_INVOICE_DETAILS_START,
            url: 'salesInvoice',
            filter: {
                where: filter,
                order: 'invoiceDate ASC',
            }
        });
        setSelected([]);
        setCustmerChange(true);
    }

    useEffect(() => {
        calculatePaymentTotal(salesInvoiceDetails ? salesInvoiceDetails : [], hiddenAmount);
    }, [customerId]);

    const handleClick = (e, data, invoiceId) => {
        // if (amount < 1 && e.target.checked) {
        //     toast.dismiss();
        //     toast.error('Amount less than invoice amount');
        //     return false;
        // }

        if (e.target.checked) {
            if (amount > 0) {

            } else {
                toast.dismiss();
                toast.error('Amount less than invoice amount');
                return false;
            }
        }
        setAutoMark(false);

        const selectedIndex = selected.indexOf(data.id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, data.id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
        calculatePayment(e, data, invoiceId, newSelected);
    };

    const calculatePayment = (e, data, invoiceId, selected) => {
        let mLines = [];
        for (const [key, value] of Object.entries(data)) {
            mLines[key] = value
        }
        let tAmount = 0;
        let autoAmount = parseFloat(amount);
        if (e.target.name === 'auto') {
            let autoMarkDiv = document.getElementById('autoMark');
            autoAmount = autoMarkDiv.getAttribute('dataamount');
        }

        let selectedArray = [];
        if (e.target.name === 'costAmount' && e.target.value !== '') {
            if (parseFloat(e.target.value) <= parseFloat(parseFloat(data.invoiceAmount - data.settledAmount).toFixed(2))) {
                mLines['costAmount'] = parseFloat(parseFloat(e.target.value).toFixed(2));
            } else {
                mLines['costAmount'] = parseFloat(parseFloat(data.invoiceAmount - data.settledAmount).toFixed(2));
            }
        } else {
            if (e.target.checked) {
                if (autoAmount > (data.invoiceAmount - data.settledAmount)) {
                    mLines['costAmount'] = parseFloat(parseFloat(data.invoiceAmount - data.settledAmount).toFixed(2));
                    tAmount = parseFloat(autoAmount - parseFloat(parseFloat(data.invoiceAmount - data.settledAmount).toFixed(2)));
                } else {
                    mLines['costAmount'] = parseFloat(parseFloat(autoAmount).toFixed(2));
                    tAmount = parseFloat(parseFloat(autoAmount - autoAmount).toFixed(2));
                }
            } else {
                tAmount = parseFloat(parseFloat(autoAmount + data.costAmount).toFixed(2));
                mLines['costAmount'] = 0;
            }
        }
        let index = salesInvoiceDetails.findIndex((d, i) => invoiceId === i);
        if (index >= 0) {
            salesInvoiceDetails.splice(index, 1, mLines);
        }

        if (e.target.name === 'costAmount' && e.target.value !== '') {
            selectedArray = salesInvoiceDetails.filter(function (el) { return selected.find(e => e === el.id) && !el.onHold });
            let tcAmount = parseFloat(selectedArray.reduce((a, v) => a = parseFloat(a) + parseFloat(v.costAmount), 0));
            tAmount = parseFloat(hiddenAmount) - parseFloat(tcAmount);
            if (hiddenAmount < tcAmount) {
                toast.dismiss();
                toast.error('Payment available only Rs.' + hiddenAmount);
                mLines['costAmount'] = currencyFormat(data.costAmount);
                salesInvoiceDetails.splice(index, 1, mLines);
                return false;
            }
        }

        calculatePaymentTotal(salesInvoiceDetails, tAmount);
    }

    const calculatePaymentTotal = (salesInvoiceDetails, a) => {
        let markedAmount = salesInvoiceDetails ? salesInvoiceDetails.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v.costAmount)), 0) : 0.00;
        setPaymentAmount(hiddenAmount);
        setMarkedAmount(markedAmount);
        setBalanceAmount(parseFloat(parseFloat(parseFloat(hiddenAmount).toFixed(2)) - markedAmount));
        setAmount(a);
    }

    const handleCostAmount = (e, data, costIndex) => {
        setAutoMark(false);
        calculatePayment(e, data, costIndex, selected);
    }

    const handleAmount = (value) => {
        setAmount(value);
        setHiddenAmount(value);
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const handleAutomark = (e) => {
        setAutoMark(e.target.checked);
        let newSelected = [];
        resetSelected();
        if (e.target.checked) {
            salesInvoiceDetails && salesInvoiceDetails.length > 0 && salesInvoiceDetails.map((data, i) => {
                let e = { 'target': { 'name': "auto", "checked": true } };
                setTimeout(function () {
                    if (data.onHold) {
                        return false;
                    }
                    // let autoMarkDiv = document.getElementById('autoMark');
                    // if (autoMarkDiv.getAttribute('dataamount') < 0) {
                    //     return false;
                    // }
                    let autoMarkDiv = document.getElementById('autoMark');
                    if (autoMarkDiv.getAttribute('dataamount') > 0) {

                    } else {
                        return false;
                    }
                    newSelected.push(data.id);
                    calculatePayment(e, data, i, newSelected);
                });
            });
        }
        setSelected(newSelected);
    }

    const resetSelected = () => {
        salesInvoiceDetails && salesInvoiceDetails.length > 0 && salesInvoiceDetails.map((data, si) => {
            let mLines = [];
            for (const [key, value] of Object.entries(data)) {
                mLines[key] = value
            }
            mLines['costAmount'] = 0;
            let index = salesInvoiceDetails.findIndex((d, i) => si === i);
            if (index >= 0) {
                salesInvoiceDetails.splice(index, 1, mLines);
            }
        });
        setPaymentAmount(0);
        setMarkedAmount(0);
        setBalanceAmount(0);
        setAmount(hiddenAmount);
    }

    const handleUnAutomark = (e) => {
        e.target.checked = false;
        handleAutomark(e);
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader
                {...props}
                cls={'newImg'}
                img={SalesIcon}
                title={'Sales'}
                links={[{ 'label': 'Sales', 'link': '/sales' }, { 'label': 'Customer Payments', 'link': '' }]}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, classes.scrollBorder)}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    <CustomAccordion
                        title={'Collect Payment'}
                        top={"0"}
                        topVisible={"50px"}
                        zIndex={9}
                        showDetails={false}
                        index={0}
                        ref={childRef}
                        component={
                            <Box
                                className={clsx(classes.removeUnderline)}
                                component="form"
                                autoComplete="off"
                                onSubmit={(e) => handleSubmit(e)}>
                                <Row gutter={50} className={classes.ButtonRelative}>
                                    {
                                        errorCommon && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <CustomAlert error={errorCommon} customClass={clsx(classes.uploadError, classes.margin10t)} />
                                        </Col>
                                    }
                                    <Col xxl={5} xl={5} lg={6} md={8} sm={24} xs={24} >
                                        <Typography variant={'h6'} className={clsx(classes.bold, classes.disInline)}>CP ---</Typography>
                                    </Col>
                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={14}>
                                        <span className={clsx(classes.statusButton, classes.collectPayment, classes.disInline)}>{capitalizeFirstLetter('CREATED')}</span>
                                    </Col>
                                    <Col xxl={14} xl={14} lg={12} md={8} sm={12} xs={10} className={clsx(classes.textAlignRight, classes.collectPayment, classes.ButtonStatic, classes.textLeft, classes.displayFlexPayment)}>
                                        <Space direction="horizontal" align="center" size={[10, 10]} className={clsx(classes.ButtonAbsolute, classes.OverallPaymentButton)}>
                                            <Button
                                                tabIndex={-1}
                                                key="confirm"
                                                onClick={() => handleConfirmSubmit()}
                                                color="primary"
                                                variant="contained"
                                                id={idNamingConversion('Confirm', 'customerPayment', 'DropDown')}
                                                className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                            >Confirm</Button>
                                            <Button
                                                tabIndex={-1}
                                                key="save"
                                                color="primary"
                                                variant="contained"
                                                id={idNamingConversion('Save', 'customerPayment', 'DropDown')}
                                                type={'submit'}
                                                className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}
                                            >Save</Button>
                                        </Space>
                                    </Col>
                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                        <AutoCompleteComponent
                                            name={["Customer Name ", <span key={"Customer Name"} className={classes.colorRedRequired}> *</span>]}
                                            heads={[{ 'key': 'name', 'name': 'Customer Name' },
                                            { 'key': 'mobile', 'name': 'Phone Number' },
                                            { 'key': 'serialNo', 'name': 'Customer ID' }]}
                                            details={customerDetails}
                                            id={idNamingConversion('Customer Name', 'customerPayment', 'DropDown')}
                                            searchType={(s) => customerApi(s)}
                                            parentValue={customObject(customerDetails, customerId)}
                                            onChange={(data) => { handleChangeCustomer(data.id) }}
                                            parentError={errorCustomerId}
                                            position={"bottom"}
                                            customClasses={classes.margin20t}
                                        />
                                    </Col>
                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                        <InputLabel className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Customer ID</InputLabel>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{customerSerialNo || '---'}</Typography>
                                    </Col>
                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                        <div className={clsx(classes.margin25t, classes.dateAdjust)}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DesktopDatePicker
                                                    fullWidth
                                                    error={errorDate && true}
                                                    helperText={errorDate}
                                                    slots={{
                                                        openPickerIcon: DateIcon
                                                    }}
                                                    views={['year', 'month', 'day']}
                                                    value={paymentDate}
                                                    label="Payment Date"
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    slotProps={{
                                                        textField: {
                                                            id: idNamingConversion('Payment Date', 'customerPayment', 'TextField'),
                                                            autoComplete: 'one-time-code'
                                                        },
                                                    }}
                                                    InputLabelProps={{
                                                        required: true
                                                    }}
                                                    format="dd/MM/yyyy"
                                                    onChange={(newValue) => { newValue !== null ? setPaymentDate(newValue) : setPaymentDate(new Date()) }}
                                                />
                                            </LocalizationProvider>
                                        </div>
                                    </Col>
                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                        <AutoCompleteComponent
                                            name={["Method of payment (MOP) "]}
                                            heads={[{ 'key': 'method', 'name': 'Method' },
                                            { 'key': 'description', 'name': 'Description' }]}
                                            details={mopDetails}
                                            id={idNamingConversion('Method of payment', 'customerPayment', 'DropDown')}
                                            parentValue={customObject(mopDetails, mopId)}
                                            onChange={(data) => setMopId(data.id)}
                                            position={"bottom"}
                                            customClasses={classes.margin25t}
                                        //parentError={errorMopId}
                                        />
                                    </Col>
                                    <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                        <AutoCompleteComponent
                                            name={["Sales Rep "]}
                                            heads={[{ 'key': 'name', 'name': 'Name' }]}
                                            id={idNamingConversion('Sales Rep', 'customerPayment', 'DropDown')}
                                            details={getTeamData && getTeamData?.filter(el => el.status === 'ACTIVE')}
                                            parentValue={customObject(getTeamData && getTeamData?.filter(el => el.status === 'ACTIVE'), salesRepId)}
                                            onChange={(data) => { console.log(data); setSalesRepId(data.id) }}
                                            position={"bottom"}
                                            customClasses={classes.margin25t}
                                        //parentError={errorMopId}
                                        />
                                    </Col>
                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                        <AutoCompleteComponent
                                            name={["Currency ", <span key={"Currency"} className={classes.colorRedRequired}> *</span>]}
                                            heads={[{ 'key': 'name', 'name': 'Currency Name' },
                                            { 'key': 'shortName', 'name': 'Currency Short Form' }]}
                                            details={currencyDetails}
                                            id={idNamingConversion('Currency', 'customerPayment', 'DropDown')}
                                            parentValue={customObject(currencyDetails, currencyId)}
                                            onChange={(data) => setCurrencyId(data.id)}
                                            parentError={errorCurrency}
                                            position={"bottom"}
                                            customClasses={classes.margin25t}
                                        />
                                    </Col>
                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                        <TextField autoComplete='one-time-code'
                                            label={["Payment Amount ", <span key={"Payment Amount"} className={classes.colorRedRequired}> *</span>]}
                                            fullWidth
                                            value={hiddenAmount}
                                            id={idNamingConversion('Payment Amount', 'customerPayment', 'TextField')}
                                            type="number"
                                            variant={'standard'}
                                            onWheel={(e) => e.target.blur()}
                                            error={errorAmount && true}
                                            helperText={errorAmount}
                                            className={clsx(classes.margin25t, { [classes.disabled]: selected && selected.length !== 0 })}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">₹ </InputAdornment>,
                                                classes: {
                                                    input: classes.textFieldColor,
                                                },
                                            }}
                                            inputProps={{
                                                step: "any",
                                                "aria-autocomplete": "none"
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom
                                            }}
                                            onFocus={(e) => { parseFloat(e.target.value) === 0 ? handleAmount('') : handleAmount(parseFloat(e.target.value)) }}
                                            onBlur={(e) => { e.target.value === '' ? handleAmount(0) : handleAmount(parseFloat(e.target.value)) }}
                                            onChange={(e) => handleAmount(e.target.value)}
                                        />
                                    </Col>

                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                        <TextField autoComplete='one-time-code'
                                            label='Payment Reference (Optional)'
                                            fullWidth
                                            variant={'standard'}
                                            className={clsx(classes.margin25t)}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            id={idNamingConversion('Payment Reference', 'customerPayment', 'TextField')}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                            onChange={(e) => setReference(e.target.value)}
                                        />
                                    </Col>
                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                        <TextField autoComplete='one-time-code'
                                            label='Description (Optional)'
                                            fullWidth
                                            variant={'standard'}
                                            className={clsx(classes.margin25t)}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            id={idNamingConversion('Description', 'customerPayment', 'TextField')}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                            onChange={(e) => setDescription(e.target.value)}
                                        />
                                    </Col>
                                    <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                        <InputLabel className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Payment Status</InputLabel>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{capitalizeFirstLetter('CREATED')}</Typography>
                                    </Col>
                                </Row>
                            </Box>
                        }
                    />
                    <CustomAccordion
                        title={'Select Invoice'}
                        top={"49"}
                        topVisible={"150px"}
                        zIndex={7}
                        showDetails={false}
                        index={1}
                        ref={childRef}
                        component={
                            <div className={clsx(classes.tableRoot, classes.tableRootSelectInvoice)} style={{ height: "100%" }}>
                                <div className={classes.overFlowSelectiveAuto}>
                                    <Row gutter={20} align="middle" style={{ marginBottom: 8 }} className={classes.overFlowSelective}>
                                        <Col xxl={4} xl={4} lg={5} md={5} sm={5} xs={5}>
                                            <div id="autoMark" className={clsx(classes.autoMark, classes.disInline, classes.verticalAlignMiddle, classes.fontSize0)} dataamount={amount}>
                                                <Tooltip style={{ marginRight: 10 }}
                                                    classes={{ popper: clsx(classes.customToolTip) }}
                                                    title="Enable Auto Mark for the system to automatically select the Invoices" arrow
                                                    placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                                    <IconButton>
                                                        <Image src={infoMarkIcon} preview={false} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                            <div className={clsx(classes.disInline, classes.verticalAlignMiddle)}>
                                                <FormControlLabel
                                                    classes={{
                                                        label: clsx(classes.fonSize14, classes.textFieldLableAutoMark, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink'),

                                                    }}
                                                    control={<Switch size='small' className={clsx(classes.customSwitch, classes.marginLeft10)}
                                                        onChange={(e) => handleAutomark(e)}
                                                    />}
                                                    id={idNamingConversion('Auto Mark', 'customerPayment', 'Radio')}
                                                    label="Auto Mark"
                                                    labelPlacement="start"
                                                    checked={autoMark}
                                                    disabled={hiddenAmount === 0 ? true : false}
                                                    className={clsx(classes.marginLeft0)}
                                                />
                                            </div>
                                        </Col>
                                        <Col xxl={16} xl={16} lg={15} md={15} sm={15} xs={15} className={classes.textAlignCenter}>
                                            <div className={clsx(classes.amountBorder)}>
                                                <div className={clsx(classes.amountBorderCenterAlign)}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.paddingright0, classes.fonSize13)}>Payment Amnt: <span className={clsx(classes.textFieldColor, classes.bold, classes.fonSize14)}>₹ {currencyFormat(paymentAmount)}</span></Typography>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.paddingright0, classes.fonSize13)}>Marked Amnt: <span className={clsx(classes.textFieldColor, classes.bold, classes.fonSize14)}>₹ {currencyFormat(markedAmount)}</span></Typography>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.paddingright0, classes.fonSize13)}>Balance Amnt: <span className={clsx(classes.textFieldColor, classes.bold, classes.fonSize14)}>₹ {currencyFormat(balanceAmount)}</span></Typography>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4} className={clsx(classes.textAlignRight, classes.textLeft)}>
                                            <Button
                                                key="confirm"
                                                type="submit"
                                                color="primary"
                                                variant="contained"
                                                className={clsx(classes.AddMoreBtn)}
                                                id={idNamingConversion('Un-Mark', 'customerPayment', 'DropDown')}
                                                onClick={(e) => handleUnAutomark(e)}
                                            >Un-Mark</Button>
                                        </Col>
                                    </Row>
                                </div>
                                <CustomInfiniteScroll
                                    heads={selectInvoiceHead}
                                    onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                                    sortOrder={sortOrder}
                                    width={true}
                                    sortBy={sortBy}
                                    loadMore={true}
                                    loadMoreContent={false}
                                    selected={selected}
                                    onSelected={(value) => setSelected(value)}
                                    component={
                                        <>
                                            {
                                                customerId && loader === true ? (
                                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                        <TableCell className={classes.textAlignCenter} colSpan={8}><div className={classes.loadMoreCircle}></div></TableCell>
                                                    </TableRow>
                                                ) : (
                                                    <React.Fragment>
                                                        {
                                                            loader === false && salesInvoiceDetails && salesInvoiceDetails.length > 0 ? salesInvoiceDetails.map((data, i) => (
                                                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={clsx({ [classes.disabled]: data?.onHold })} key={i}>
                                                                    <TableCell>
                                                                        {
                                                                            !data?.onHold ?
                                                                                <Checkbox checked={selected.find(e => e === data.id) ? true : false} id={`checkbox_${i}`}
                                                                                    className={clsx({ [classes.disabled]: amount === '' || data.billStatus === 'REVERSED' })} onChange={(e) => handleClick(e, data, i)} /> : ''
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell style={{ width: getColumnWidth(selectInvoiceHead, 1) }}><span style={{ width: getColumnWidth(selectInvoiceHead, 1) }}>{data.serialNo}</span></TableCell>
                                                                    <TableCell style={{ width: getColumnWidth(selectInvoiceHead, 1) }}><span style={{ width: getColumnWidth(selectInvoiceHead, 2) }}>{moment(data.invoiceDate).format('DD MMM YYYY')}</span></TableCell>
                                                                    <TableCell className={classes.rightAlignAmount} style={{ width: getColumnWidth(selectInvoiceHead, 3) }}><span style={{ width: getColumnWidth(selectInvoiceHead, 1) }}>₹ {data.invoiceAmount ? currencyFormat(data.invoiceAmount - data.settledAmount) : '0.00'}</span></TableCell>
                                                                    <TableCell className={classes.rightAlignAmount} style={{ width: getColumnWidth(selectInvoiceHead, 4) }}>
                                                                        <span style={{ width: getColumnWidth(selectInvoiceHead, 4) }}><TextField autoComplete='one-time-code'
                                                                            fullWidth
                                                                            type={'number'}
                                                                            name="costAmount"
                                                                            id={idNamingConversion(`Cost Amount_${i}`, 'customerPayment', 'Radio')}
                                                                            value={data.costAmount && data.costAmount > 0 ? data.costAmount : (selected.find(e => e === data.id) ? "" : 0)}
                                                                            className={clsx(classes.textAreaAdjust, classes.dataCostAmount, { [classes.dataCostAmountText]: selected.find(e => e === data.id) })}
                                                                            // multiline={true}
                                                                            onChange={(e) => handleCostAmount(e, data, i)}
                                                                            InputProps={{
                                                                                startAdornment: <InputAdornment position="start">₹ </InputAdornment>,
                                                                                classes: {
                                                                                    input: classes.textFieldColor,
                                                                                },
                                                                                step: "any"
                                                                            }}
                                                                            onWheel={(e) => e.target.blur()}
                                                                            InputLabelProps={{
                                                                                className: classes.textAreaLableColorCustom,
                                                                            }}
                                                                        /></span>
                                                                    </TableCell>
                                                                    <TableCell className={classes.rightAlignAmount} style={{ width: getColumnWidth(selectInvoiceHead, 5) }}><span style={{ width: getColumnWidth(selectInvoiceHead, 1) }}>₹ {data.invoiceAmount ? currencyFormat(parseFloat(parseFloat(data.invoiceAmount - data.settledAmount).toFixed(2)) - parseFloat(data.costAmount)) : '0.00'}</span></TableCell>
                                                                    <TableCell className={clsx(classes.textAlignRight)} style={{ width: getColumnWidth(selectInvoiceHead, 6) }}>
                                                                        <span style={{ width: getColumnWidth(selectInvoiceHead, 1) }}>  {data?.onHold ? <span style={{ display: "inline-block" }} className={clsx(classes.statusButton)}>Hold</span> :
                                                                            <span style={{ display: "inline-block" }} className={clsx(classes.statusButton, { [classes.openButton]: data.costAmount === null || data.costAmount === 0 }, { [classes.fullButton]: (parseFloat(data.costAmount) === parseFloat(parseFloat(data.invoiceAmount - data.settledAmount).toFixed(2))) })}>
                                                                                {
                                                                                    (parseFloat(data.costAmount) === parseFloat(parseFloat(data.invoiceAmount - data.settledAmount).toFixed(2))) ? "Full" : data.costAmount === null || data.costAmount === 0 ? "Open" : "Partial"
                                                                                }
                                                                            </span>
                                                                        }
                                                                        </span>
                                                                    </TableCell>
                                                                </TableRow>
                                                            )) : (
                                                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                                    <TableCell className={classes.textAlignCenter} colSpan={8}> <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Currently there is no open invoice to settle against payment'}</p></TableCell>
                                                                </TableRow>
                                                            )
                                                        }
                                                    </React.Fragment>
                                                )
                                            }
                                        </>
                                    }
                                />
                            </div>
                        }
                        lastContent={true}
                    />
                </div>
            </div>
            <Modal
                title={'System Override Confirmation'}
                open={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                className={clsx(classes.commonPopup, classes.deletePopup, classes.removeUnderline)}
                // closeIcon={<CloseIcon />}
                footer={[
                    <Button
                        key="yes"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn)}
                        id={idNamingConversion('Yes', 'customerPayment', 'DropDown')}
                    // onClick={() => deleteBill()}
                    >Yes</Button>,
                    <Button
                        key="no"
                        type='submit'
                        color='primary'
                        variant="contained"
                        id={idNamingConversion('No', 'customerPayment', 'DropDown')}
                        className={clsx(classes.modalBtn, classes.AddMoreBtn)}
                        onClick={() => handleCancel()}>
                        No
                    </Button>,
                ]}>
                <p>Do you want to override system selected Invoices to settle?</p>
            </Modal>
            <CustomModal
                visible={confirm}
                title='Payment Confirmation'
                yesButton='Yes'
                loading={createLoader}
                noButton='No'
                text={<p>Are you sure do you want to Confirm the Payment?</p>}
                onOpen={() => handleSubmit('', 'CONFIRMED')}
                onClose={() => setConfirm(false)}
            />
        </React.Fragment >
    )

}
export default CustomerPaymentCreate